import React from "react";
import { InputGroup, Form, Button } from "react-bootstrap";
import { Icon } from "src/components";

type AllProps = {
  disabled: boolean;
  filter_param: string;
  onChange: (value: string) => void;
  onClick: () => void;
  placeholder?: string;
}

// Description: Filter component that is used in leftContent of ToolbarWrapper component 
function ToolbarFilterComponent(props: AllProps) {
  const { disabled, filter_param, onChange, onClick, placeholder } = props;
  return <InputGroup size="sm">
    <InputGroup.Text>
      <Icon className="ficon-filter" />
    </InputGroup.Text>
    <Form.Control
      id="filter_tb"
      disabled={disabled}
      value={filter_param}
      onChange={(e) => onChange(e.target.value)}
      type="text"
      placeholder={placeholder ?? "Filter..."}
      aria-label="Filter"
      autoComplete="off"
    />
    {
      !!filter_param &&
      <Button
        variant="icon"
        size="sm"
        aria-label="Clear Filter"
        className="input-group-btn"
        onClick={onClick}>
        <Icon className="ficon-x-circle" />
      </Button>
    }
  </InputGroup>;
}

export default React.memo(ToolbarFilterComponent);
